let CustomOrder = require('../../../../common/custom-order/index');
let Controls = require('./controls/index');
const css = require('./editable-order.css');

class EditableOrder {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let isEditable = this.$context.props.isEditable;
        return this.$context.getWatcherData().then((data) => Object.assign({ isEditable }, data, { css }));
    }
}

module.exports = {
    constructor: EditableOrder,
    children: [
        {
            name: 'custom-order',
            component: CustomOrder,
            props: {
                isSmallTree: 'true',
                dontUseMetric: 'true'
            },
            watcher: {
                hideRubrics: ['order', 'computed', 'hideRubrics']
            }
        },
        {
            name: 'controls',
            component: Controls,
            watcher: {
                isViewOnlyMode: ['order', 'isDisabled'],
                isFilerValuesControlEnabled: ['account', 'orders', 'computed', 'componentsState',
                    'isFilerValuesControlEnabled']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/editable-order/index.js